import { createContext } from "react";
import { ContactViewStore } from "../stores/ContactViewStore";

export const ContactViewStoreContext = createContext(new ContactViewStore());
